/**
 * Feste Startwerte fuer das Finanzen-Modul: Kategorien je Buchungstyp und
 * Zahlwege. Jeweils mit Emoji fuer die Chip-Darstellung beim Schnell-Erfassen.
 * Bewusst als Konstanten gehalten (KISS) – spaeter leicht erweiterbar.
 */

export const TYP_AUSGABE = 'ausgabe';
export const TYP_EINNAHME = 'einnahme';

// Ausgaben-Kategorien (Reihenfolge = Anzeige-Reihenfolge der Chips).
export const KATEGORIEN_AUSGABE = [
  { name: 'Lebensmittel', icon: '🛒' },
  { name: 'Wohnen', icon: '🏠' },
  { name: 'Mobilität', icon: '🚗' },
  { name: 'Restaurant', icon: '🍽️' },
  { name: 'Freizeit', icon: '🎉' },
  { name: 'Shopping', icon: '🛍️' },
  { name: 'Abos', icon: '🔁' },
  { name: 'Gesundheit', icon: '💊' },
  { name: 'Sonstiges', icon: '📦' },
];

// Einnahme-Kategorien.
export const KATEGORIEN_EINNAHME = [
  { name: 'Gehalt', icon: '💼' },
  { name: 'Zinsen', icon: '📈' },
  { name: 'Erstattung', icon: '↩️' },
  { name: 'Geschenk', icon: '🎁' },
  { name: 'Sonstiges', icon: '📦' },
];

// Zahlwege – "Handy" steht bewusst vorne und ist die Vorbelegung.
export const ZAHLWEGE = [
  { name: 'Handy', icon: '📱' },
  { name: 'Karte', icon: '💳' },
  { name: 'Bar', icon: '💶' },
  { name: 'Überweisung', icon: '🏦' },
];

export const STANDARD_ZAHLWEG = 'Handy';

// Emoji-Auswahl fuer selbst angelegte Kategorien (kuratiert, gut erkennbar).
export const EMOJI_AUSWAHL = [
  '📦', '🛒', '🏠', '🚗', '🍽️', '🎉', '🛍️', '💊', '💼', '🎁',
  '✈️', '📱', '💡', '🐶', '🎮', '☕', '👕', '⛽', '🏋️', '📚',
  '🎬', '💳', '🎓', '🩺', '🎵', '🌱', '🔧', '💶', '🏦', '❤️',
];

/** Liefert die festen Standard-Kategorien passend zum Buchungstyp. */
export const kategorienFuer = (typ) =>
  typ === TYP_EINNAHME ? KATEGORIEN_EINNAHME : KATEGORIEN_AUSGABE;

/**
 * Mischt Standard- und benutzerdefinierte Kategorien fuer einen Buchungstyp.
 * Eigene Kategorien mit gleichem Namen wie ein Standard werden ausgelassen.
 */
export const mischeKategorien = (typ, eigene = []) => {
  const basis = kategorienFuer(typ);
  const zusatz = (eigene || [])
    .filter((k) => k.typ === typ && !basis.some((b) => b.name === k.name))
    .map((k) => ({ name: k.name, icon: k.icon || '📦' }));
  return [...basis, ...zusatz];
};

/** Emoji einer Kategorie (fuer Listen/Chips) inkl. eigener Kategorien; Fallback neutrales Symbol. */
export const kategorieIcon = (typ, name, eigene = []) => {
  const treffer = mischeKategorien(typ, eigene).find((k) => k.name === name);
  return treffer ? treffer.icon : '📦';
};

/** Emoji eines Zahlwegs; Fallback leer. */
export const zahlwegIcon = (name) => {
  const treffer = ZAHLWEGE.find((z) => z.name === name);
  return treffer ? treffer.icon : '';
};
